import './Legal.css';

function PrivacyPolicy() {
    return <div className='legal'>
        <h1>Privacy policy</h1>
        <p>This Service is provided by Drealight at no cost and is intended for use as is.</p>
        <p>This page is used to inform visitors regarding our policies with the collection, use, and disclosure of Personal Information if anyone decided to use our Service.</p>
        <p>If you choose to use our Service, then you agree to the collection and use of information in relation to this policy. The Personal Information that we collect is used for providing and improving the Service. We will never sell your information, and will not use or share your information with anyone except as described in this Privacy Policy.</p>
        <p>The terms used in this Privacy Policy have the same meanings as in our Terms and Conditions.</p>

        <h2>Information Collection and Use</h2>

        <p>For a better experience, while using our Service, we may require you to provide us with certain personally identifiable information, including but not limited to IDFA. The information that we request will be retained by us and used as described in this privacy policy.</p>
        <p>The app does use third-party services that may collect information used to identify you.</p>
        <p>Link to the privacy policy of third party service providers used by the app:</p>

        <ul>
            <li><a href="https://facebook.com/about/privacy">https://facebook.com/about/privacy</a></li>
            <li><a href="https://gameanalytics.com/privacy">https://gameanalytics.com/privacy</a></li>
            <li><a href="https://www.adjust.com/terms/privacy-policy/">https://www.adjust.com/terms/privacy-policy/</a></li>
            <li><a href="https://www.voodoo.io/">https://www.voodoo.io/</a></li>
        </ul>

        <h2>Log Data</h2>
        <p>We want to inform you that whenever you use our Service, in a case of an error in the app we collect data and information (through third-party products) on your phone called Log Data. This Log Data may include information such as your device Internet Protocol (“IP”) address, device model, operating system version, the configuration of the app when utilizing our Service, the time and date of your use of the Service, and other statistics.</p>

        <h2>Service Providers</h2>
        <p>We may employ third-party companies and individuals due to the following reasons:</p>
        <p>To facilitate our Service;</p>
        <ul>
            <li>To provide the Service on our behalf;</li>
            <li>To perform Service-related services; or</li>
            <li>To assist us in analyzing how our Service is used.</li>
        </ul>
        <p>We want to inform users of this Service that these third parties have access to your Personal Information. The reason is to perform the tasks assigned to them on our behalf. However, they are obligated not to disclose or use the information for any other purpose.</p>

        <h2>Security</h2>
        <p>We value your trust in providing us your Personal Information, thus we are striving to use commercially acceptable means of protecting it. But remember that no method of transmission over the internet, or method of electronic storage is 100% secure and reliable, and we cannot guarantee its absolute security.</p>

        <h2>Links to Other Sites</h2>
        <p>This Service may contain links to other sites. If you click on a third-party link, you will be directed to that site. Note that these external sites are not operated by us. Therefore, we strongly advise you to review the Privacy Policy of these websites. We have no control over and assume no responsibility for the content, privacy policies, or practices of any third-party sites or services.</p>

        <h2>Children’s Privacy</h2>
        <p>Our Service does not address anyone under the age of 13. We do not knowingly collect personally identifiable information from children under 13. In the case we discover that a child under 13 has provided us with personal information, we immediately delete this from our servers. If you are a parent or guardian and you are aware that your child has provided us with personal information, please contact us so that we will be able to do the necessary actions.</p>

        <h2>Changes to This Privacy Policy</h2>
        <p>We may update our Privacy Policy from time to time. Thus, you are advised to review this page periodically for any changes. We will notify you of any changes by posting the new Privacy Policy on this page. These changes are effective immediately after they are posted on this page.</p>

        <h2>Request User Data Deletion</h2>
        <p>When you install and use Drealight mobile applications, we can collect and process some of your data for different legitimate purposes.</p>
        <p>You will find below explanations regarding the reasons why we may collect data.</p>

        <h2>Why is data collected?</h2>
        <p>Drealight and its third-party partners collect data:</p>
        <ul>
            <li>To provide you with the services you asked for</li>
            <li>To run analytics and understand how users interact with our product and services in order to continuously improve it</li>
        </ul>
        <p>The third-party partners that Drealight will share the data with are:</p>
        <ul>
            <li>GameAnalytics</li>
            <li>Facebook Analytics</li>
            <li>Adjust</li>
            <li>Voodoo</li>
        </ul>

        <h2>Data deletion requests</h2>
        <p>To delete user data collected by Drealight, please reach out to sergio@drealight.com</p>
        <p>If you also want to request the deletion of the data that may have been collected about you or your device by our third-party partners that are acting as independent data controllers, you will find below the contact for each partner and the link to the relevant section of their privacy policies:</p>
        <p>GameAnalytics:</p>
        <ul>
            <li>email: privacy@gameanalytics.com</li>
            <li>privacy policy: <a href="https://gameanalytics.com/privacy/#6-changing-or-deleting-your-information">https://gameanalytics.com/privacy/#6-changing-or-deleting-your-information</a></li>
        </ul>

        <p>Facebook Analytics:</p>
        <ul>
            <li>email: none, please refer to the privacy policy</li>
            <li>privacy policy: <a href="https://www.facebook.com/policy.php">https://www.facebook.com/policy.php</a></li>
        </ul>

        <p>Adjust:</p>
        <ul>
            <li>email: privacy@adjust.com</li>
            <li>privacy policy: <a href="https://www.adjust.com/terms/privacy-policy/">https://www.adjust.com/terms/privacy-policy/</a></li>
        </ul>

        <p>Voodoo:</p>
        <ul>
            <li>email: dpo@voodoo.io</li>
            <li>privacy policy: <a href="https://www.voodoo.io">https://www.voodoo.io</a></li>
        </ul>
    </div>;
}

export default PrivacyPolicy;